import { Button, Search } from '@usitsdasdesign/dds-react';
import Icon from 'atoms/Icon';
import FilterContext from './FilterContext';
import FilterDatePicker from './FilterDatePicker';
import FilterSelect from './FilterSelect';
import SelectAndSearch from './SelectAndSearch';
import SortingDrop from './SortingDrop';
import { useCallback } from 'react';
import { debounce } from 'helper/util';

function FiltersAndSort({
    type = 'filter',
    control,
    register,
    setValue,
    watch,
    fields = [],
    filters,
    onItemsSelect,
    onRemove,
    onClearAll,
    className,
    searchFilterItems,
    onSearch,
    onApply,
    onSaveFilter,
    onShowSavedFilters,
    isFilterDisabled,
    disableSave = false,
    isShowFilter = true,
    isShowFilterSearch = true,
    isDisabledSaveBtn = false,
    isDisablePagination = false,
    isSearchWithTag = false,
    isInsideDrawer = false,
}) {
    const typeStyle = {
        sorting: 'arrange_vertically__s__stroke',
        filter: 'filter__l__stroke',
        search: 'search__l__stroke'
    };

    const debouncedOnApply = useCallback(debounce(onApply, 500), [onApply]);

    return (
        <div className={`bg-neutral-50 p-2 relative overflow-y-auto md:overflow-y-visible scroll-hidden ${className}`}>
            <div className={`flex items-start justify-between gap-2 ${isInsideDrawer ? 'md:flex-wrap' : 'md:flex-nowrap'}`}>
                 <div className='flex-1 flex md:flex-wrap items-center gap-2'>
                    <Icon icon={typeStyle[type]} color='black' size='w-4 h-4' />
                    {
                        type === 'search' && (
                            <SelectAndSearch
                                searchValueFor={watch('filterSearchFor').value}
                                control={control}
                                register={register}
                                onChange={(val) => setValue('filterSearchFor', val)}
                                options={searchFilterItems}
                                searchValue={watch('filterSearch') || ''}
                                valueChanged={(val) => setValue('filterSearch', val)}
                                onSearch={onSearch}
                                isSearchWithTag={isSearchWithTag}
                            />
                        )
                    }

                    {
                        fields.map((field) => {
                            switch (field.type) {
                                case 'select':
                                    return (
                                        <FilterSelect
                                            key={field.id}
                                            id={field.id}
                                            control={control}
                                            register={register}
                                            name={field.name}
                                            placeholder={field.label}
                                            options={field.options}
                                            watch={watch}
                                            onRemove={() => onRemove(field)}
                                            label={field.label}
                                            onApply={onApply}
                                            loadOptions={field?.loadOptions}
                                            isMulti={field?.isMulti}
                                            setValue={setValue}
                                            isPaginate={field?.isPaginate}
                                            isDisablePagination={isDisablePagination}
                                        />
                                    );
                                case 'calendar':
                                    return (
                                        <FilterDatePicker
                                            name={field.name}
                                            onRemove={() => onRemove(field)}
                                            watch={watch}
                                            setValue={setValue}
                                            size='s'
                                            label={field.label}
                                            icon='calendar__l__stroke'
                                            maxDate={
                                                typeof field?.maxDate === 'function'
                                                    ? field.maxDate(watch('filters.startDate'), watch('filters.endDate'))
                                                    : field?.maxDate
                                            }
                                            minDate={
                                                typeof field?.minDate === 'function'
                                                    ? field.minDate(watch('filters.startDate'), watch('filters.endDate'))
                                                    : field?.minDate
                                            }
                                        />
                                    );
                                case 'sorting':
                                    return (
                                        <SortingDrop
                                            watch={watch}
                                            label={field.label}
                                            name={field.name}
                                            onChange={(val) => setValue(field.name, val)}
                                            onRemove={() => onRemove(field)}
                                        />
                                    );
                                default:
                                    return null;
                            }
                        })
                    }
                    {
                        isShowFilter && (
                            <FilterContext
                                type={type}
                                icon='plus__l__stroke'
                                kind='silent'
                                label={`Add ${(type === 'filter' || type === 'search') ? 'filter' : 'sort'}`}
                                size="s"
                                color='dark'
                                menuItems={filters}
                                onItemsSelect={onItemsSelect}
                                onShowSavedFilters={onShowSavedFilters}
                                isDisabled={isFilterDisabled}
                                disableSave={disableSave}
                            />
                        )
                    }
                </div>
                <div className='flex items-center gap-2 flex-none'>
                    {
                        (type === 'filter' && isShowFilterSearch) && (
                            <Search
                                icon="search__s__stroke"
                                placeholder="Search"
                                size="m"
                                value={watch('filterSearch') || ''}
                                searchValue={watch('filterSearch')}
                                valueChanged={(val) => {
                                    setValue('filterSearch', val);
                                    debouncedOnApply();
                                }}
                            />
                        )
                    }
                    <Button
                        kind='primary'
                        label='Clear all'
                        onClick={onClearAll}
                    />
                    {
                        (type === 'filter' && !disableSave) && (
                            <Button
                                label='Save'
                                color='blue'
                                isDisabled={!isDisabledSaveBtn}
                                onClick={onSaveFilter}
                            />
                        )
                    }
                    <Button
                        label='Apply'
                        onClick={onApply}
                    />
                </div>
            </div>
        </div>
    );
}

export default FiltersAndSort;
